import { fetchMainTaskSprints } from '../../../projects/developmentSprint.service'

import { mapSprintListToOptions } from './sprintUtils'

const optionsCache = new Map()
const inflight = new Map()

const parseSprintList = (response) => {
    const body = response?.data ?? {}
    if (Array.isArray(body?.data)) return body.data
    if (Array.isArray(body)) return body
    return []
}

export const getCachedProjectSprintOptions = (projectId) => {
    if (!projectId) return null
    return optionsCache.get(projectId) ?? null
}

export const fetchProjectSprintOptions = async (
    projectId,
    { force = false } = {}
) => {
    if (!projectId) return []

    if (force) {
        optionsCache.delete(projectId)
    } else if (optionsCache.has(projectId)) {
        return optionsCache.get(projectId)
    }

    if (!force && inflight.has(projectId)) {
        return inflight.get(projectId)
    }

    const request = (async () => {
        try {
            const response = await fetchMainTaskSprints({ projectId })
            const options = mapSprintListToOptions(parseSprintList(response))
            optionsCache.set(projectId, options)
            return options
        } catch {
            if (!optionsCache.has(projectId)) {
                optionsCache.set(projectId, [])
            }
            return optionsCache.get(projectId) ?? []
        } finally {
            if (inflight.get(projectId) === request) {
                inflight.delete(projectId)
            }
        }
    })()

    inflight.set(projectId, request)
    return request
}

export const clearProjectSprintOptionsCache = (projectId) => {
    if (projectId) {
        optionsCache.delete(projectId)
        inflight.delete(projectId)
        return
    }
    optionsCache.clear()
    inflight.clear()
}
